export default __webpack_public_path__ + "static/media/empty_chats.b51b5781.svg";